'use client';

import React from 'react';
import { Button } from '@/components/common/Button';
import { Icon } from '@/components/common/Icon';
import { Tooltip } from '@/components/common/Tooltip';
import { useTranslations } from '@/core/translations';
import { useFullscreenStore } from './FullscreenStore';
import styles from './FullscreenExitButton.module.scss';

export const FullscreenExitButton: React.FC = () => {
  const t = useTranslations('general');
  const setFullscreen = useFullscreenStore((state) => state.setFullscreen);

  return (
    <div className={styles.container}>
      <Tooltip label={t('exitFullscreen')} placement="left">
        <Button transparent aria-label={t('exitFullscreen')} onClick={() => setFullscreen(false)}>
          <Icon name="FullscreenExitIcon" fillColor />
        </Button>
      </Tooltip>
    </div>
  );
};
